<template>
    <header-leafly />
  
    <!-- 1.1 公司整体介绍第一部分：大图背景 + 简短文字 -->
    <section class=" relative w-full bg-cover bg-center "  style="height:800px;"
      :style="`background-image: url(${cmsConfig.websiteName}/images/why-leafly/banner-01.jpg)`">
      <div class="absolute inset-0 bg-gradient-to-r from-black/50 to-black/30"></div>
      <div class="container mx-auto px-4 h-full flex items-center justify-center relative z-10">
        <div class="max-w-4xl text-center">
          <h1 class="text-5xl md:text-6xl font-bold text-white mb-6" data-aos="fade-up">
            Smart Packaging Solutions Since 2014
          </h1>
          <p class="text-xl md:text-2xl text-white/90" data-aos="fade-up" data-aos-delay="200">
            From Shenzhen to the World - Delivering Quality, Innovation & Reliability
          </p>
        </div>
      </div>
    </section>
  
    <!-- 1.2 公司整体介绍第二部分：详细内容，左右布局 -->
    <section class="py-20 bg-white">
      <div class="container mx-auto px-4">
        <div class="flex flex-col lg:flex-row gap-12 items-center">
          <div class="w-full lg:w-1/2" data-aos="fade-right">
            <h2 class="text-4xl font-bold mb-6 text-gray-800">About Leafly Packaging</h2>
            <p class="text-lg text-gray-600 mb-4 leading-relaxed">
              Founded in 2014 and based in Shenzhen, China — a city known for its high quality and efficient service — Leafly Packaging has been providing smart, reliable packaging solutions for over 10 years.
            </p>
            <p class="text-lg text-gray-600 mb-4 leading-relaxed">
              We specialize in cannabis, food, and cosmetic packaging, offering a full range of products including paper boxes, plastic bags, glass containers, and plastic containers.
            </p>
            <p class="text-lg text-gray-600 mb-4 leading-relaxed">
              With more than 500 brands trusting us for OEM packaging, we bring your creative ideas to life quickly and precisely — helping your brand stand out with packaging that inspires confidence and quality.
            </p>
            <p class="text-lg text-gray-600 leading-relaxed">
              From design and dieline creation to sampling, mass production, and delivery, we handle every step with precision and care, ensuring your packaging vision becomes reality.
            </p>
          </div>
          <div class="w-full lg:w-1/2" data-aos="fade-left">
            <div class="rounded-lg overflow-hidden shadow-2xl aspect-video relative">
              <!-- YouTube iframe -->
               <!-- <iframe
                class="w-full h-full"
                :src="videoSrc"
                title="About Leafly Packaging"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen>
              </iframe>  -->

                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/sDt_WOulrqg"
                    title="Leaflypackaging paper box automated production line ," frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
                </iframe>

              <!-- 播放按钮覆盖层 -->
              <div
                v-if="!isVideoPlaying"
                class="absolute inset-0 bg-black/40 flex items-center justify-center cursor-pointer group transition-all duration-300 hover:bg-black/30"
                @click="playVideo">
                <div class="w-20 h-20 bg-white/90 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 group-hover:bg-white transition-all duration-300">
                  <svg class="w-10 h-10 text-green-600 ml-1" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  
    <!-- 2. 公司人员介绍 -->
    <section class="pt-20 pb-30 bg-gray-50">
      <div class="container mx-auto px-4">
        <div class="text-center mb-16" data-aos="fade-up">
          <h2 class="text-4xl font-bold mb-4 text-gray-800">Our Team</h2>
          <p class="text-xl text-gray-600 max-w-3xl mx-auto">
            Meet the dedicated professionals who make Leafly Packaging a trusted partner for brands worldwide
          </p>
        </div>
  
        <!-- 员工展示网格 -->
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-20">
          <div v-for="member in teamMembers" :key="member.id" 
            class="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300"
            data-aos="fade-up" 
            :data-aos-delay="member.id * 100">
            <div class="aspect-square overflow-hidden">
              <img :src="member.imageUrl" 
                :alt="member.name" 
                class="w-full h-full object-cover hover:scale-110 transition-transform duration-500">
            </div>
            <div class="p-4 text-center">
              <h3 class="font-semibold text-gray-800 mb-1">{{ member.name }}</h3>
              <p class="text-sm text-gray-600">{{ member.position }}</p>
            </div>
          </div>
        </div>
  
        <!-- 团队合照板块 - Sales Department -->
        <div class="bg-white rounded-lg shadow-lg overflow-hidden mb-12" data-aos="fade-up">
          <div class="flex flex-col lg:flex-row">
            <div class="w-full lg:w-1/2 p-4">
              <img :src="`/leaflypackaging-com/images/why-leafly/save-team.jpg`" 
                alt="Sales Department Team" 
                class="w-full h-full object-cover min-h-[400px]">
            </div>
            <div class="w-full lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center">
              <h3 class="text-3xl font-bold mb-6 text-gray-800">Sales Department – Global Client Partnership</h3>
              <div class="space-y-4 text-gray-600 text-lg leading-relaxed">
                <p>
                  The Sales department functions as Leafly's primary client interface, combining deep technical product knowledge with strategic account management capabilities. Sales professionals maintain long-term relationships with beauty, fragrance, and pharmaceutical brands while identifying emerging market opportunities across multiple regions.
                </p>
                <p>
                  With teams positioned in China, the USA, and the UAE, plus European representatives, the department provides localized service that accounts for regional market preferences and regulatory requirements. This distributed structure enables rapid response to client inquiries and on-ground support for sampling, prototyping, and technical consultations.
                </p>
                <p>
                  Sales team members work collaboratively with R&D and production departments to coordinate custom OEM/ODM projects, ensuring client specifications translate accurately from concept through final delivery. Their role encompasses everything from initial needs assessment to post-delivery support and continuous improvement initiatives.
                </p>
              </div>
            </div>
          </div>
        </div>
  
        <!-- 团队合照板块 - Production Department (右侧图片) -->
        <div class="bg-white rounded-lg shadow-lg overflow-hidden mb-12" data-aos="fade-up">
          <div class="flex flex-col lg:flex-row-reverse">
            <div class="w-full lg:w-1/2 p-4">
              <img :src="`/leaflypackaging-com/images/why-leafly/production-2.jpg`" 
                alt="Production Department Team" 
                class="w-full h-full object-cover min-h-[400px]">
            </div>
            <div class="w-full lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center">
              <h3 class="text-3xl font-bold mb-6 text-gray-800">Production Department – Manufacturing Excellence</h3>
              <div class="space-y-4 text-gray-600 text-lg leading-relaxed">
                <p>
                  Our production team operates state-of-the-art facilities equipped with advanced printing, die-cutting, and finishing equipment. With over 10 years of manufacturing experience, we ensure every packaging product meets the highest quality standards.
                </p>
                <p>
                  The department manages the entire production workflow, from material preparation to final inspection. Our skilled technicians and quality control specialists work together to maintain consistency across small-batch samples and large-scale production runs.
                </p>
                <p>
                  By implementing lean manufacturing principles and continuous process optimization, we achieve fast turnaround times without compromising quality. Our production capacity allows us to handle diverse project requirements while maintaining flexibility for custom specifications.
                </p>
              </div>
            </div>
          </div>
        </div>
  
        <!-- 团队合照板块 - Design & R&D Department -->
        <div class="bg-white rounded-lg shadow-lg overflow-hidden" data-aos="fade-up">
          <div class="flex flex-col lg:flex-row">
            <div class="w-full lg:w-1/2  p-4">
              <img :src="`/leaflypackaging-com/images/why-leafly/design.jpg`" 
                alt="Design & R&D Team" 
                class="w-full h-full object-cover min-h-[400px]">
            </div>
            <div class="w-full lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center">
              <h3 class="text-3xl font-bold mb-6 text-gray-800">Design & R&D Department – Creative Innovation</h3>
              <div class="space-y-4 text-gray-600 text-lg leading-relaxed">
                <p>
                  Our design and R&D team transforms concepts into tangible packaging solutions. Combining creative expertise with technical knowledge, they develop structural designs and visual artwork that align with brand identity and functional requirements.
                </p>
                <p>
                  The team stays ahead of industry trends, exploring new materials, printing techniques, and sustainable alternatives. They work closely with clients to understand brand positioning and create packaging that resonates with target audiences.
                </p>
                <p>
                  From initial sketches to 3D renderings and physical prototypes, our designers ensure every detail is perfected before production begins. Their collaborative approach with sales and production teams guarantees seamless execution of even the most complex custom projects.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  
    <!-- 3. 公司Certifications -->
    <section class="py-20 bg-white">
      <div class="container mx-auto px-4">
        <div class="text-center mb-16" data-aos="fade-up">
          <h2 class="text-4xl font-bold mb-4 text-gray-800">Our Certifications</h2>
          <p class="text-xl text-gray-600 max-w-3xl mx-auto">
            Committed to excellence and compliance with international standards
          </p>
        </div>
  
        <div class="flex flex-col lg:flex-row gap-12 items-center">
          <!-- 左侧：认证轮播图 -->
          <div class="w-full lg:w-1/2 h-[700px]" data-aos="fade-right">
            <div class="relative bg-gray-100 rounded-lg p-8 h-full">
              <div ref="certSwiperEl" class="swiper certification-swiper">
                <div class="swiper-wrapper">
                  <div v-for="cert in certifications" :key="cert.id" class="swiper-slide">
                    <div class="flex items-center justify-center h-[400px]">
                      <img :src="cert.imageUrl" 
                        :alt="cert.name" 
                        class="max-w-full max-h-full object-contain">
                    </div>
                    <div class="text-center mt-4">
                      <h3 class="text-xl font-semibold text-gray-800">{{ cert.name }}</h3>
                    </div>
                  </div>
                </div>
                <div class="cert-swiper-pagination swiper-pagination"></div>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
              </div>
            </div>
          </div>
  
          <!-- 右侧：可折叠的认证详情 -->
          <div class="w-full lg:w-1/2" data-aos="fade-left">
            <div class="space-y-4">
              <div v-for="(cert, index) in certificationDetails" :key="index" 
                class="border border-gray-200 rounded-lg overflow-hidden">
                <button 
                  @click="toggleCertification(index)"
                  class="w-full px-6 py-4 bg-white hover:bg-gray-50 flex items-center justify-between transition-colors">
                  <div class="flex items-center gap-4">
                    <div class="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-green-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                      </svg>
                    </div>
                    <h3 class="text-xl font-semibold text-gray-800 text-left">{{ cert.title }}</h3>
                  </div>
                  <svg 
                    :class="['w-6 h-6 text-gray-600 transition-transform duration-300', activeCertification === index ? 'rotate-180' : '']"
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    stroke-width="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </button>
                <div 
                  v-show="activeCertification === index"
                  class="px-6 py-4 bg-gray-50 border-t border-gray-200">
                  <p class="text-gray-600 leading-relaxed">{{ cert.description }}</p>
                  <div v-if="cert.benefits" class="mt-4">
                    <h4 class="font-semibold text-gray-800 mb-2">Key Benefits:</h4>
                    <ul class="list-disc list-inside space-y-1 text-gray-600">
                      <li v-for="(benefit, idx) in cert.benefits" :key="idx">{{ benefit }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  
    <!-- 4. Sustainability - ESG -->
    <section class="hero-gallery-wrapper">
      <!-- ESG 总体介绍 -->
      <div class="hero-gallery-item">
        <div class="gallery-item-sticky sustainability-hero-sticky">
          <div class="text-center relative min-h-screen flex items-center justify-center sustainability-hero-bg">
            <div class="absolute inset-0 bg-black/35"></div>
            <div class="container mx-auto px-4 relative z-10 py-12">
              <div class="max-w-4xl mx-auto">
                <h2 class="text-4xl font-bold mb-6 text-white">Sustainability & ESG Commitment</h2>
                <div>
                  <h3 class="text-2xl font-semibold mb-4 text-green-200">What is ESG?</h3>
                  <p class="text-lg text-white/90 mb-6 leading-relaxed">
                    ESG stands for Environmental, Social, and Governance — a framework that evaluates how organizations operate responsibly and sustainably. At Leafly Packaging, ESG principles guide our business decisions, ensuring we create value not just for our clients, but for our communities and the planet.
                  </p>
                  <h3 class="text-2xl font-semibold mb-4 text-green-200">Why ESG Matters</h3>
                  <p class="text-lg text-white/90 leading-relaxed">
                    In today's world, sustainable packaging is no longer optional — it's essential. Consumers demand eco-friendly solutions, regulations are tightening, and brands need partners who can deliver both quality and responsibility. Our ESG commitment ensures that every packaging solution we provide contributes to a more sustainable future while meeting the highest standards of social responsibility and ethical governance.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 5. Sustainability - ESG具体内容 -->
    <section class="hero-gallery-wrapper">
          <!-- ESG 四个维度 -->
      <div class="hero-gallery-item">
        <div class="gallery-item-sticky sustainability-dimensions-sticky">
          <div class="bg-white py-16">
            <div class="container mx-auto px-4">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-7xl mx-auto">
                <!-- Environmental Responsibility -->
                <div class="bg-gray-50 rounded-xl shadow-lg p-8">
                  <div class="flex items-center gap-4 mb-6">
                    <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-green-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                        <path d="M2 17l10 5 10-5"></path>
                        <path d="M2 12l10 5 10-5"></path>
                      </svg>
                    </div>
                    <h3 class="text-2xl font-bold text-gray-800">Environmental Responsibility</h3>
                  </div>
                  <div class="space-y-4 text-gray-600">
                    <p class="leading-relaxed">
                      We prioritize eco-friendly materials and sustainable manufacturing processes.
                    </p>
                    <ul class="space-y-2 pl-4">
                      <li class="flex items-start gap-2"><span class="text-green-600">✓</span><span>FSC-certified paper sourcing</span></li>
                      <li class="flex items-start gap-2"><span class="text-green-600">✓</span><span>Energy-efficient production</span></li>
                      <li class="flex items-start gap-2"><span class="text-green-600">✓</span><span>85% material utilization</span></li>
                    </ul>
                  </div>
                </div>
                <!-- Social Impact -->
                <div class="bg-gray-50 rounded-xl shadow-lg p-8">
                  <div class="flex items-center gap-4 mb-6">
                    <div class="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-blue-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                      </svg>
                    </div>
                    <h3 class="text-2xl font-bold text-gray-800">Social Impact</h3>
                  </div>
                  <div class="space-y-4 text-gray-600">
                    <p class="leading-relaxed">
                      We believe in creating positive social impact through fair labor practices.
                    </p>
                    <ul class="space-y-2 pl-4">
                      <li class="flex items-start gap-2"><span class="text-blue-600">✓</span><span>Fair wages and benefits</span></li>
                      <li class="flex items-start gap-2"><span class="text-blue-600">✓</span><span>Training programs</span></li>
                      <li class="flex items-start gap-2"><span class="text-blue-600">✓</span><span>Safe working conditions</span></li>
                    </ul>
                  </div>
                </div>
                <!-- Governance -->
                <div class="bg-gray-50 rounded-xl shadow-lg p-8">
                  <div class="flex items-center gap-4 mb-6">
                    <div class="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-purple-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                      </svg>
                    </div>
                    <h3 class="text-2xl font-bold text-gray-800">Governance & Compliance</h3>
                  </div>
                  <div class="space-y-4 text-gray-600">
                    <p class="leading-relaxed">
                      Strong governance and ethical business practices form our foundation.
                    </p>
                    <ul class="space-y-2 pl-4">
                      <li class="flex items-start gap-2"><span class="text-purple-600">✓</span><span>ISO 9001 certification</span></li>
                      <li class="flex items-start gap-2"><span class="text-purple-600">✓</span><span>FDA & EU compliance</span></li>
                      <li class="flex items-start gap-2"><span class="text-purple-600">✓</span><span>Transparent supply chain</span></li>
                    </ul>
                  </div>
                </div>
                <!-- Economic Benefits -->
                <div class="bg-gray-50 rounded-xl shadow-lg p-8">
                  <div class="flex items-center gap-4 mb-6">
                    <div class="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-amber-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="12" y1="1" x2="12" y2="23"></line>
                        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                      </svg>
                    </div>
                    <h3 class="text-2xl font-bold text-gray-800">Economic Benefits</h3>
                  </div>
                  <div class="space-y-4 text-gray-600">
                    <p class="leading-relaxed">
                      Our ESG approach delivers tangible economic value.
                    </p>
                    <ul class="space-y-2 pl-4">
                      <li class="flex items-start gap-2"><span class="text-amber-600">✓</span><span>Cost savings through efficiency</span></li>
                      <li class="flex items-start gap-2"><span class="text-amber-600">✓</span><span>Enhanced brand value</span></li>
                      <li class="flex items-start gap-2"><span class="text-amber-600">✓</span><span>Long-term partnerships</span></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ESG 承诺总结 -->
      <div class="hero-gallery-item-last">
        <div class="gallery-item-sticky sustainability-commitment-sticky">
          <div class="bg-gradient-to-r from-green-600 to-green-700 py-20">
            <div class="container mx-auto px-4">
              <div class="text-white text-center max-w-4xl mx-auto">
                <h3 class="text-3xl font-bold mb-4">Our ESG Commitment</h3>
                <p class="text-lg leading-relaxed">
                  At Leafly Packaging, sustainability is embedded in everything we do. Together with our clients, we're building a more sustainable future, one package at a time.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <sectionCTA/>
    <footer-index />
  </template>
  
  <script setup lang="ts" name="SinglePageWhyLeafly">
  import type { SinglePage } from '~/types';
  import headerLeafly from '../../components/header/header-leafly.vue'
  import footerIndex from '../../components/footer/footer-index.vue'
  import sectionCTA from '../../components/common/sectionCTA.vue'
  import cmsConfig from '~/cmsConfig'
  import cmsUtils from '~/utils/cmsUtils';
  import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
  import Swiper from 'swiper'
  import { Autoplay, Navigation, Pagination } from 'swiper/modules'
  import type { Swiper as SwiperType } from 'swiper'
  import 'swiper/css'
  import 'swiper/css/navigation'
  import 'swiper/css/pagination'
  
  const props = defineProps<{
    singlePage: SinglePage
  }>()

  const cmsInfo = await cmsUtils.getCmsInfo()
  const route = useRoute()
  const baseUrl = (cmsInfo.website.https ? 'https://' : 'http://') + cmsInfo.website.domain
  const canonicalUrl = baseUrl + route.path.replace('.html','')
  useHead({
      script: [
          {
              type: 'application/ld+json',
              innerHTML: JSON.stringify({
                  '@context': 'https://schema.org',
                  '@type': 'Organization',
                  name: cmsInfo.website.title,
                  description: props.singlePage.description,
                  url: canonicalUrl,
                  foundingDate: '2014',
                  foundingLocation: 'Shenzhen, China',
                  slogan: 'Smart Packaging Solutions Since 2014',
                  award: [
                      'ISO 9001:2015 Quality Management',
                      'ISO 14001:2015 Environmental Management',
                      'FSC Forest Stewardship Council',
                      'FDA Food & Drug Administration Compliance',
                      'SGS Product Quality Certification',
                      'BSCI Business Social Compliance Initiative',
                      'G7 Color Management'
                  ],
                  knowsAbout: [
                      'Custom Packaging',
                      'Cannabis Packaging',
                      'Food Packaging',
                      'Cosmetic Packaging',
                      'OEM Packaging Solutions'
                  ]
              })
          }
      ]
  })

  // YouTube 视频播放控制
  const isVideoPlaying = ref(false)
  // 初始加载时就包含 autoplay=1，但视频不会自动播放（因为 iframe 还没有焦点）
  // 点击后通过 postMessage 触发播放
const videoSrc = ref('https://www.youtube-nocookie.com/embed/sDt_WOulrqg?enablejsapi=1&controls=1&modestbranding=1&rel=0&autoplay=0')

  const playVideo = () => {
    isVideoPlaying.value = true
    // 使用 postMessage 直接控制 YouTube 播放器，避免重新加载 iframe
    const iframe = document.querySelector('iframe[src*="youtube"]') as HTMLIFrameElement
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        'https://www.youtube-nocookie.com/embed/sDt_WOulrqg'
      )
    }
  }
  
  // 团队成员数据
  const teamMembers = ref([
    { id: 1, name: 'Joanna', position: 'Sales Director', imageUrl:"/leaflypackaging-com/images/why-leafly/img-01.jpg"},
    { id: 2, name: 'Joyce', position: 'Sales Manager' , imageUrl:"/leaflypackaging-com/images/why-leafly/img-02.jpg"},
    { id: 3, name: 'Jane', position: 'Sales Manager' , imageUrl:"/leaflypackaging-com/images/why-leafly/img-03.jpg"},
    { id: 4, name: 'sTeve', position: 'General Manager' , imageUrl:"/leaflypackaging-com/images/why-leafly/img-04.jpg"},
    { id: 5, name: 'Jsper Fang', position: 'Manufacturing Process Engineer' , imageUrl:"/leaflypackaging-com/images/why-leafly/img-05.jpg"},
    { id: 7, name: 'Lea', position: 'Sales Manager' , imageUrl:"/leaflypackaging-com/images/why-leafly/img-06.jpg"},
    { id: 6, name: 'Fanny', position: 'Sales Manager' , imageUrl:"/leaflypackaging-com/images/why-leafly/img-07.jpg"},
    { id: 8, name: 'Sunny', position: 'Quality Control' , imageUrl:"/leaflypackaging-com/images/why-leafly/img-08.jpg"},
  ])
  
  // 认证轮播数据
  const certifications = ref([
    { id: 1, name: 'ISO 9001:2015 Quality Management',imageUrl:'/leaflypackaging-com/images/why-leafly/cert/ISO9001.jpg' },
    { id: 2, name: 'ISO 14001:2015 Quality Management',imageUrl:'/leaflypackaging-com/images/why-leafly/cert/iso1400.jpg' },
    { id: 3, name: 'FSC Forest Stewardship Council' ,imageUrl:'/leaflypackaging-com/images/why-leafly/cert/FSC.jpg'},
    { id: 4, name: 'SGS Product Quality Certification' ,imageUrl:'/leaflypackaging-com/images/why-leafly/cert/sgs-1.jpg'},
    { id: 5, name: 'SGS Product Quality Certification' ,imageUrl:'/leaflypackaging-com/images/why-leafly/cert/sgs-2.jpg'},
    { id: 6, name: 'SGS Product Quality Certification' ,imageUrl:'/leaflypackaging-com/images/why-leafly/cert/sgs-3.jpg'},
    { id: 7, name: 'G7 Color Manager' ,imageUrl:'/leaflypackaging-com/images/why-leafly/cert/G7-color-manager.jpg'},
  
  ])
  
  // 认证详情（可折叠）
  const certificationDetails = ref([
    {
      title: 'ISO 9001:2015 - Quality Management System',
      description: 'Our ISO 9001:2015 certification demonstrates our commitment to consistent quality management across all operations. This internationally recognized standard ensures that our processes, from design to delivery, meet rigorous quality benchmarks and customer satisfaction requirements.',
      benefits: [
        'Consistent product quality and reliability',
        'Continuous improvement in processes and services',
        'Enhanced customer satisfaction and trust',
        'Reduced waste and increased operational efficiency'
      ]
    },
    {
      title: 'FSC - Forest Stewardship Council',
      description: 'FSC certification guarantees that our paper and wood-based materials come from responsibly managed forests. This certification ensures environmental protection, social benefits, and economic viability in forestry practices.',
      benefits: [
        'Sustainable sourcing of raw materials',
        'Protection of biodiversity and ecosystems',
        'Support for local communities and indigenous rights',
        'Traceability throughout the supply chain'
      ]
    },
    {
      title: 'FDA - Food & Drug Administration Compliance',
      description: 'Our FDA compliance certification ensures that all food and pharmaceutical packaging meets strict safety standards. We adhere to regulations for materials that come into direct contact with consumable products.',
      benefits: [
        'Safe packaging for food and pharmaceutical products',
        'Compliance with U.S. and international regulations',
        'Material safety testing and documentation',
        'Consumer health protection and brand credibility'
      ]
    },
    {
      title: 'SGS - Product Quality & Safety Certification',
      description: 'SGS certification validates our product quality, safety standards, and testing procedures. As a globally recognized testing and certification body, SGS ensures our packaging meets international quality benchmarks.',
      benefits: [
        'Independent third-party quality verification',
        'International market access and acceptance',
        'Risk mitigation and quality assurance',
        'Enhanced brand reputation and customer confidence'
      ]
    },
    {
      title: 'BSCI - Business Social Compliance Initiative',
      description: 'BSCI certification demonstrates our commitment to ethical business practices and social responsibility. We ensure fair labor conditions, worker rights, and ethical supply chain management throughout our operations.',
      benefits: [
        'Fair labor practices and worker welfare',
        'Ethical supply chain management',
        'Compliance with international labor standards',
        'Corporate social responsibility and transparency'
      ]
    }
  ])
  
  const activeCertification = ref<number | null>(0)
  
  const toggleCertification = (index: number) => {
    activeCertification.value = activeCertification.value === index ? null : index
  }
  
const certSwiperEl = ref<HTMLElement | null>(null)
let certSwiperInstance: SwiperType | null = null
  
  const initCertSwiper = () => {
    if (!import.meta.client || !certSwiperEl.value) return
    certSwiperInstance?.destroy(true, true)
    certSwiperInstance = null
  
    const slideCount = certifications.value.length
    if (slideCount === 0) return
  
    certSwiperInstance = new Swiper(certSwiperEl.value, {
      modules: [Autoplay, Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 24,
      loop: slideCount > 1,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet cert-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active cert-pagination-bullet-active',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  }

  // 滚动监听 - 实现覆盖效果
  onMounted(() => {
    nextTick(() => {
      initCertSwiper()
    })
  })

  onBeforeUnmount(() => {
    certSwiperInstance?.destroy(true, true)
    certSwiperInstance = null
  })
  </script>
  
<style lang='scss'>
.hero-gallery-wrapper {
  position: relative;
}

.hero-gallery-item {
  position: relative;
}

.hero-gallery-item-last {
  position: relative;
}

.gallery-item-sticky {
  position: sticky;
  top: 0;
}

.sustainability-hero-sticky {
  z-index: 80;
}

.sustainability-dimensions-sticky {
  z-index: 90;
}

.sustainability-commitment-sticky {
  z-index: 100;
}

.gallery-scroll-distance {
  height: 50vh;
}

.sustainability-hero-bg {
  width: 100%;
  background-image: url('/leaflypackaging-com/images/why-leafly/sustainability-background.avif');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
  
  .certification-swiper {
    width: 100%;
    height: 100%;
    position: relative;
    padding-bottom: 2.75rem;
  }
  
  .swiper-slide {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  
  .certification-swiper .swiper-button-prev,
  .certification-swiper .swiper-button-next {
    color: #059669;
  }
  
  .cert-swiper-pagination {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    padding-top: 0.75rem;
    pointer-events: auto;
  }
  
  :deep(.cert-pagination-bullet) {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 9999px;
    background: #d1d5db;
    opacity: 1;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.2s ease;
  }
  
  :deep(.cert-pagination-bullet-active) {
    background: #059669;
    transform: scale(1.15);
  }
  </style>
